import { useTranslation } from 'react-i18next'
import { AiButton } from '@/components/ui/ai-button'

interface GenerateInsightsButtonProps {
  onClick: () => void | Promise<void>
  disabled?: boolean
  /** When true, render with "primary"-style emphasis (used in empty states). */
  emphasis?: 'primary' | 'inline'
  className?: string
  children?: React.ReactNode
}

export function GenerateInsightsButton({
  onClick,
  disabled,
  emphasis = 'primary',
  className,
  children,
}: GenerateInsightsButtonProps) {
  const { t } = useTranslation()
  return (
    <AiButton
      type="button"
      emphasis={emphasis === 'primary' ? 'solid' : 'subtle'}
      size={emphasis === 'primary' ? 'lg' : 'sm'}
      disabled={disabled}
      onClick={() => void onClick()}
      className={className}
    >
      {children ?? t('investigations.graph.aiInsights.generateInsights')}
    </AiButton>
  )
}
